const data = {
  Products:[{
  id: 2, 
  name: "Limited Fall Edition Sneakers",
  price: 125.00
}]}

export default data